<template>
  <div
    class="relative px-2.5 py-1.5 my-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white">
    <div class="relative flex justify-end items-center w-full">
      <div v-if="getActions().length > 0"
        class="col-span-5 tablet:col-span-1 absolute top-[5px] laptop:top-[10px] right-2.5 tablet:relative flex items-center justify-end gap-[5px] mobile:z-[1] tablet:!z-auto laptop:z-[1]">
        <div class="w-max mobile:hidden tablet:block laptop:hidden">
          <span
            class="mobile:hidden laptop:block text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base largeDesktop:font-poppins inline-block">Status</span>
          <p v-if="item.status_slug == 'pending'"
            class="inline-block text-center py-[1px] px-[10px] text-[14px] rounded-[5px] mb-0 text-white bg-[#F39C12]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'approved'"
            class="inline-block text-center py-[1px] px-[3px] text-[14px] rounded-[5px] mb-0 text-white bg-[#65B741]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'payment_failed' || item.status_slug == 'suspended'"
            class="inline-block text-center py-[1px] px-[3px] text-[14px] rounded-[5px] mb-0 text-white bg-[#D7385E]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'rejected'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-[5px] mb-0 text-white bg-[#D7385E]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'active'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-[5px] mb-0 text-white bg-[#73B7E5] capitalize">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'cancelled'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-[5px] mb-0 text-white bg-[#D7385E] capitalize">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'payment_retry'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-[5px] mb-0 text-white bg-[#448AFF] capitalize">
            {{ item.status_text }}</p>
          <p v-else>-</p>
        </div>
        <div ref="dropdownWrapper">
          <div class="relative flex">
            <button class="focus:outline-none" @click="toggleDropdown">
              <img src="../../assets/images/white-ellipse.svg" alt="Up Down Arrow" class="w-[32px] h-[32px]">
            </button>
            <ul v-if="isOpen"
              class="absolute top-[35px] right-0 z-10 mt-1 w-[200px] bg-white rounded shadow-lg text-[#333333] text-[15px] font-poppins py-[5px]">
              <span class="absolute -top-[10px] right-[10px] w-0 h-0
                border-l-[6px] border-l-transparent
                border-r-[6px] border-r-transparent
                border-b-[12px] border-b-white"></span>
              <li v-for="option in getActions()" :key="option" @click="select(option)"
                class="px-2 py-[5px] mx-[10px] my-[2px] rounded-md border-[1px] border-[#E5D3B7] bg-[#E5D3B7]/20 cursor-pointer text-left">
                {{ option }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="relative grid grid-cols-4 tablet:grid-cols-5 laptop:grid-cols-12 largeDesktop:grid-cols-12 gap-2.5 laptop:gap-1.5 largeDesktop:gap-2.5 break-words tablet:mt-[10px]">
      <div class="col-span-3 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Agreement
          ID:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal">
          {{ $helper.isEmpty(item.agreement_id) ? '-' : item.agreement_id }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-3 relative group">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">
          Plan Name:
        </span>
        <!-- Show full name directly on mobile -->
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal block tablet:hidden">
          {{ item.plan_name }}
        </p>
        <!-- Short name + tooltip on tablet and above -->
        <p
          class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal relative hidden tablet:block">
          {{ getShortPlanName(item.plan_name) }}
          <span class="opacity-0 group-hover:!opacity-100 transition-opacity duration-300 max-w-[250px]
             absolute left-0 top-full mt-1 z-10 bg-white text-black text-[16px] tablet:text-[14px] laptop:text-[16px]
             px-2 py-1 rounded shadow-xl border border-gray-300">
            {{ item.plan_name }}
          </span>
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Purchase
          Date:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal">
          {{ $helper.isEmpty(item.sale_date) ? '-' : $helper.formattedDate(item.sale_date) }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Activation
          Date:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal">
          {{ item.activation_date }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Plan
          Amount:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal">
          ${{ $helper.isEmpty(item.total_amount) ? '-' : $helper.formatAmount(item.total_amount) }}
          <span class="mobile:text-base tablet:text-base">/{{
            item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
          }}</span>
        </p>
      </div>
      <div
        class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1 mobile:block tablet:hidden desktop:block">
        <div class="w-max">
          <span
            class="block text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base largeDesktop:font-poppins mobile:block laptop:inline-block">Status:</span>
          <p v-if="item.status_slug == 'pending'"
            class="inline-block text-center py-[1px] px-[10px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#F39C12]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'approved'"
            class="inline-block text-center py-[1px] px-[3px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#65B741]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'payment_failed'|| item.status_slug == 'suspended'"
            class="inline-block text-center py-[1px] px-[3px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#D7385E]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'rejected'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#D7385E]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'active'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#65B741] capitalize">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'cancelled'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#D7385E] capitalize">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'payment_retry'"
            class="inline-block text-center py-[1px] px-[15px] text-[14px] laptop:text-[16px] rounded-[5px] mb-0 text-white bg-[#448AFF] capitalize">
            {{ item.status_text }}</p>
          <p v-else>-</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ["item"],
  components: {
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getActions() {
      let res = ["Details"]
      if (this.item.status_slug != "cancelled") {
        res.push("Cancel")
      }
      if (this.item.status_slug == "payment_retry") {
        res.push("Process Payment")
      }
      return res
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(value) {
      // this.selected = value;
      this.isOpen = false;
      this.$emit('update', this.item, value); // emit change if needed
    },

    getShortPlanName(name) {
      if (this.$helper.isEmpty(name)) return '-';
      return name.length > 30 ? name.substring(0, 30) + '...' : name;
    },

    handleClickOutside(event) {
      if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
        this.isOpen = false;
      }
    },

    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  }
};
</script>